import { Typography } from "@material-ui/core"

export const DefaultSettingsMissing=()=>{
    return<>
    <Typography><strong>Step 1:</strong> Go to the <strong>Settings</strong> menu.</Typography>
            <Typography><strong>Step 2:</strong> Select the System Menu.</Typography>
            <Typography><strong>Step 3:</strong> Upload your logo.</Typography>
            </>
}